import { css } from '@emotion/react'
import { RefreshIcon } from '@ruguoapp/jike-fe-icons'
import { type HTMLMotionProps } from 'motion/react'
import { useMemo } from 'react'
import ClickWrapper from './ClickWrapper'

export interface ServiceWorkerUpdateTipProps extends HTMLMotionProps<'div'> {
	show?: boolean
	onClick?: () => void
}

// 处理图标和渐变的子组件
function GradientIcon() {
	return (
		<div
			css={css`
				display: flex;
			`}
		>
			<RefreshIcon
				css={css`
					width: 24px;
					height: 24px;
					stroke: url('#sw-icon-gradient');

					path {
						stroke: inherit;
					}
				`}
			/>
			{/* 添加 SVG 渐变定义 */}
			<svg width="0" height="0">
				<defs>
					<linearGradient id="sw-icon-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
						<stop offset="0%" stopColor="var(--tint-jike-yellow)" />
						<stop offset="100%" stopColor="var(--tint-jike-blue)" />
					</linearGradient>
				</defs>
			</svg>
		</div>
	)
}

// 处理内容的子组件
function Content() {
	return (
		<div
			css={css`
				background: linear-gradient(to right, var(--tint-jike-yellow), var(--tint-jike-blue));
				background-clip: text;
				color: transparent;
			`}
		>
			<div
				css={css`
					/* font-weight: 600; */
				`}
			>
				新版已就绪
			</div>
		</div>
	)
}

export default function ServiceWorkerUpdateTip({
	show = false,
	onClick,
	...props
}: ServiceWorkerUpdateTipProps) {
	const animationProps = useMemo(
		() => ({
			initial: {
				opacity: 0,
				y: '100%',
			},
			animate: {
				opacity: 1,
				y: !show ? '100%' : 0,
				transition: {
					duration: 0.6,
					type: 'spring',
					damping: 20,
				},
			},
		}),
		[show]
	)

	return (
		<ClickWrapper
			whileTap={{
				scale: 0.98,
			}}
			onClick={onClick}
			css={css`
				position: fixed;
				z-index: 1;
				right: 32px;
				bottom: -1px;
				background-color: var(--bg-body-1);
				box-shadow: 0 0 4px 1px var(--solid-shadow-1);
				border-radius: 12px 12px 0 0;
				border: 1px solid var(--tint-separator);
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 6px;
				padding: 8px 12px;
			`}
			{...animationProps}
			{...props}
		>
			<GradientIcon />
			<Content />
		</ClickWrapper>
	)
}
